import { unEscapeHTML } from '../Utils/text_functions.js';
import * as log from 'loglevel'

const scrollToBottom = async () => {
  try {
    const chatLog = document.getElementsByClassName("chat-log")[0];
    if (chatLog && chatLog.lastElementChild) {
      const lastChild = chatLog.lastElementChild;
      const offsetTop = lastChild.offsetTop;

      chatLog.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  }
  catch (error) {
    console.error(error);
  }
};

function checkMode(currentChats, key, mode) {
  try {
    var newChats = currentChats.filter(a => a.id === key)
    if (newChats.length === 0) {
      return true;
    }
    var chat = newChats[0];
    // check items in content
    let found_code = false;
    let found_content = false;
    if (chat.content && chat.content.length > 0) {
      // loop through each item and if they have a .code property, check if it is null
      for (var i = 0; i < chat.content.length; i++) {
        if (chat.content[i].code !== null && chat.content[i].code !== undefined) {  
          found_code = true;
          break;
        }
        else if (chat.content[i].content !== null && chat.content[i].content !== undefined) {  
          found_content = true;
          break;
        }
      }
    }
    if (chat.content && chat.content.length === 1) {
      return true;
    }
    if (mode === 'code' && found_code) {
      return true;
    }
    if (mode === 'prose' && found_content) {
      return true;
    }
    if (mode === 'chat' && !found_code && !found_content) {
      return true;
    }
    return false;
  }
  catch (e) {
    console.log(e)
    return true;
  }
}

function estimateRequestSizeBytes(chatMessages, file) {
  // 1. Size of chat history
  const chatHistoryJson = JSON.stringify(chatMessages);
  const chatHistorySize = new Blob([chatHistoryJson]).size; 
    // or simply: chatHistoryJson.length, though Blob() is more accurate in browsers

  // 2. Size of file(s) (if present)
  let fileSize = 0;
  if (file && file.size) {
    fileSize = file.size; // size in bytes
  } else if (Array.isArray(file)) {
    fileSize = file.reduce((total, f) => total + (f.size || 0), 0); // sum of all file sizes
  }

  // 3. Sum them (+ some overhead if you want)
  const overhead = 10024; // 10 KB overhead for form fields, boundary, etc. (tweak as needed)
  return chatHistorySize + fileSize + overhead;
}

function trimChatHistoryForSize(chatMessages, file, maxSizeBytes) {
  // Keep removing the earliest messages until under the limit or no messages left
  while (chatMessages.length > 1) {
    let estimatedSize = estimateRequestSizeBytes(chatMessages, file);
    if (estimatedSize <= maxSizeBytes) {
      break;
    }
    // Remove the oldest message from the front
    chatMessages.shift();
  }
  return chatMessages;
}

function trimChatHistoryByCount(chatMessages, file, maxCount) {
  try {
    // If total messages exceed maxCount, remove older ones from the front
    var tmp_output = chatMessages;
    if (chatMessages.length > maxCount) {
      // keep only the last maxCount messages
      tmp_output = chatMessages.slice(chatMessages.length - maxCount);
    }

    // remove button and HTML entities
    var output = [] 
    tmp_output.forEach(item => {        
      var new_item = JSON.parse(JSON.stringify(item));
      new_item = cleanMessage(new_item);
      output.push(new_item)
    });

    const MAX_SIZE_BYTES = 495 * 1024 * 1024; 
    return trimChatHistoryForSize(output, file, MAX_SIZE_BYTES);
  }
  catch (err) {
    log.error(`/trimChatHistoryByCount: Error: ${err.message}`);
    return chatMessages;
  }
}

function cleanMessage(new_item) {
  if (new_item.message_orig && new_item.message_orig !== null && new_item.message_orig !== '') {
    new_item.message = new_item.message_orig;
  }
  // Unescape HTML in the message
  new_item.message = unEscapeHTML(new_item.message);

  if(new_item.message.indexOf('{"images":') !== -1 && (new_item.message.indexOf('"model": "google-imagen-3"}}') !== -1)) {
    new_item.message = 'Image generated by Google Imagen-3';
    new_item.images = null;
  }
  if(new_item.message.indexOf('{"images":') !== -1 && (new_item.message.indexOf('"model": "gpt-image-1"}}') !== -1)) {
    new_item.message = 'Image generated by GPT-Image-1';
    new_item.images = null;
  }

  // Set message_orig to null
  new_item.message_orig = null;
  return new_item;
} 

export { scrollToBottom, checkMode, trimChatHistoryByCount, cleanMessage };